import { render, staticRenderFns } from "./Oauth2AuthorizeAPI.vue?vue&type=template&id=1ede7a0a&scoped=true&"
import script from "./Oauth2AuthorizeAPI.vue?vue&type=script&lang=js&"
export * from "./Oauth2AuthorizeAPI.vue?vue&type=script&lang=js&"
import style0 from "./Oauth2AuthorizeAPI.vue?vue&type=style&index=0&id=1ede7a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ede7a0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VContainer,VFlex,VForm,VLayout,VSpacer,VTextField})
